<template>
  <section v-if="props.origin == 'basket'">
  <div v-if="store.buttonFlag[props.id]">
    <button class="btn btn-primary rounded-circle d-flex justify-content-center me--5" style="height: 28px;width: 28px;" @click="store.addToBasket(1,props.sid,props.id,props.quantity)"><i class="fa fa-plus" style="vertical-align:middle"></i></button>
  </div>
  <div class="border border-1 rounded d-flex bg-primary  me--5" style="width: 70px;" v-else>
      <button class="border-0 bg-transparent text-light" style="width:33%;font-size: 14px;"  @click="store.addToBasket(3,props.sid,props.id,props.quantity)" ><i class="fa fa-minus" style="vertical-align: middle;"></i></button>
      <div class="text-center text-light" style="width:33%;font-size: 16px" >{{ convertToPersian(String(store.inputNumber[props.id])) }}</div>
      <button class="border-0 bg-transparent text-light" style="width:33%;font-size: 14px" @click="store.addToBasket(2,props.sid,props.id,props.quantity)"><i class="fa fa-plus" style="vertical-align: middle;"></i></button>
  </div>
  </section>
  <section v-if="props.origin == 'product'">
    <div class="sc-dlsm5e-0 hZkLjq add-to-card" style="justify-content: flex-end !important" v-if="store.buttonFlag[props.id]">
    <!-- آیکون پلاس روی محصولات -->
      <button v-if="props.flag != 'single' " @click="store.addToBasket(1,props.sid,props.id,props.quantity)" class="sc-134jao0-0 dEQKBM sc-dlsm5e-1 EwhD add-to-cart primary small primary icon-right no-title has-icon basic" style="height: 2.2rem !important;background:white !important"> 
        <span class="icon">
          <i class="fa fa-plus" aria-hidden="true" style="color:blue"></i>
        </span>
        <span class="title"></span> 
      </button>
      <!-- کلید افزودن در صفحه محصول -->
      <button v-else @click="store.addToBasket(1,props.sid,props.id,props.quantity)" style="height: 2.1rem !important;background-color:rgb(35, 71, 251) !important;color:white;font-size: 14px;border: 0.1rem solid rgba(35, 71, 251, 0.12);padding-right: 1.4rem;padding-left: 1.2rem; border-radius: 0.8rem !important;margin-right: .5em;position:absolute">
        افزودن به سبد خرید
      </button>
    </div>
    <!-- کلید + و - در صفحه محصول و محصولات سایت -->
    <div class="sc-dlsm5e-0 hZkLjq add-to-card added-to-card" v-else>
      <div class="sc-zf172p-0 iqRUeo">
        <div class="sc-zf172p-1 rSyRp">
          <button @click="store.addToBasket(3,props.sid,props.id,props.quantity)" class="sc-134jao0-0 dEQKBM sc-zf172p-2 bzHGXa trash-item naked small primary icon-right no-title has-icon basic"> 
            <span class="icon">
              <i class="fa fa-minus" aria-hidden="true" style="color:white"></i>
            </span> 
            <span class="title"></span> 
          </button>
        </div>
        <div class="sc-zf172p-3 dyVwIZ"><span>{{convertToPersian(String(store.inputNumber[props.id])) }}</span></div>
        <div class="sc-zf172p-1 rSyRp">
          <button @click="store.addToBasket(2,props.sid,props.id,props.quantity)" class="sc-134jao0-0 dEQKBM sc-zf172p-2 bzHGXa plus-icon naked small primary icon-right no-title has-icon basic"> 
            <span class="icon">
              <i class="fa fa-plus" aria-hidden="true" style="color:white"></i>
            </span> 
            <span class="title"></span> 
          </button>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { defineProps, ref, computed, watch, defineEmits } from 'vue';
import { convertToPersian,numberFormat } from '@/composables/digits.js';
const props = defineProps(['id', 'sid', 'flag', 'quantity','origin'])
import { useProcessProduct } from '@/store/product'
const store = useProcessProduct();
const propsFlag = computed(() => props.id || 1);
watch(propsFlag, () => {
  store.verifySelect(props.sid,props.id);
}, {
  immediate: true
});
</script>
<style scoped>
.small{
  font-size: small;
}
.hZkLjq button {
    min-width: unset;
}
.hZkLjq {
 display: flex;
    justify-content: center;
    align-items: stretch;
    position: absolute;
    z-index: 1;
    left: 0px;
    top: 8px;
    width: 100% !important;
}
.sc-134jao0-0{
    background-color: transparent !important;
        height: fit-content o !important;
        vertical-align: sub;
}
.fa{
    font-size: 15px !important;
}
.dEQKBM.small.no-title {
    background-color: white;
    width: 2.2rem;
}
.dEQKBM.small {
    height: 1rem !important ;
    font-size: 1.4rem;
}
.dEQKBM {
    border: none;
    background: none;
    text-align: center;
    border-radius: 0.6rem;
    padding: 0px;
    display: inline-flex;
    position: relative;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    cursor: pointer;
}
.dEQKBM .icon {
    display: inline-block;
}

.bzHGXa.trash-item {
    border: none !important;
}
.dEQKBM.small {
    height: 3.2rem;
    font-size: 1.4rem;
}
.dEQKBM.outline, .dEQKBM.ghost, .dEQKBM.naked {
    color: rgb(35, 71, 251);
}

.bzHGXa {
    border-radius: 50%;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    border: 0.1rem solid rgba(36, 70, 245, 0.12) !important;
    width: 1.2rem !important;
    padding: 0px !important;
}

.bzHGXa.trash-item svg {
    color: rgb(255, 255, 255);
    width: 1.8rem !important;
    height: 1.8rem !important;
    display: flex !important;
}
.htdvqk > div > small {
    display: inline-block;
    margin-right: 0.4rem;
    text-decoration: line-through;
    color: rgb(163, 163, 163);
    font-size: 1.1rem;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
}
.htdvqk small {
    font-size: 1rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: rgb(97, 100, 117);
}

.dyVwIZ {
    flex: 1 1 0%;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    text-align: center;
    /* padding: 0.2rem 0.8rem 0px; */
    /* font-size: 1.6rem; */
    font-size: 21px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: rgb(255, 255, 255);
}
.iqRUeo {
    display: flex;
    align-items: center;
    background-color: rgb(35, 71, 251);
    padding: 0px 1rem;
    border-radius: 0.8rem;
    box-shadow: rgb(0 0 0 / 4%) 0px 0.8rem 1rem 0px, rgb(0 0 0 / 8%) 0px 0.5rem 0.5rem 0px;
    transition: all 0.3s ease 0s;
    margin: 0px 0.8rem;
    width: 100% !important;
}
.EwhD {
    background: rgb(255, 255, 255);
    color: white;
    border: 0.1rem solid rgba(35, 71, 251, 0.24);
    box-shadow: rgb(0 0 0 / 4%) 0px 0.8rem 1rem 0px, rgb(0 0 0 / 8%) 0px 0.5rem 0.5rem 0px;
    line-height: normal;
    overflow: hidden;
    position: absolute;
    left: 0.8rem;
    top: 0px;
    font-size: 1.2rem !important;
    border-radius: 1.7rem !important;
}

.me--5{
  margin-left: .15em;
}
</style>